<template>
  <v-dialog v-model="dialog" persistent max-width="700px">
    <v-card>
      <v-toolbar color="#313a46">
        <v-card-title class="text-h5 white--text"
          >Logins adicionais</v-card-title
        >
        <v-spacer></v-spacer>
        <v-btn color="error" @click="closeModal()" icon>
          <v-icon>mdi-close-circle</v-icon>
        </v-btn>
      </v-toolbar>
      <v-progress-linear
        class="mt-1"
        v-if="loading"
        indeterminate
        color="primary"
      ></v-progress-linear>

      <v-card-text>
        <v-container>
          <v-form
            v-can:permission="'login-adicional#store'"
            @keydown.esc="closeModal()"
            ref="formAdditionalLogin"
          >
            <v-row>
              <v-col cols="6">
                <v-text-field
                  v-model="itemsForm.chave"
                  label="Chave"
                  :rules="[rules.required]"
                  @keyup.enter="createLoginAdditional()"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="itemsForm.valor"
                  label="Valor"
                  :rules="[rules.required]"
                  required
                  @keyup.enter="createLoginAdditional()"
                  ><v-icon
                    ref="teste"
                    @click="createLoginAdditional()"
                    slot="append"
                    color="gray"
                  >
                    mdi-plus
                  </v-icon></v-text-field
                >
              </v-col>
            </v-row>
          </v-form>
          <v-row>
            <v-col cols="12">
              <div v-for="(item, index) in loginsAdicionais" :key="index">
                <v-row no-gutters>
                  <v-col cols="6">
                    <v-text-field
                      class="mr-5"
                      :disabled="statusInput[index]"
                      v-model="item.chave"
                      @click:prepend="changeStatus(index)"
                      dense
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="5">
                    <v-text-field
                      :disabled="statusInput[index]"
                      v-model="item.valor"
                      @click:prepend="changeStatus(index)"
                      dense
                    >
                    </v-text-field>
                  </v-col>
                  <v-col center="justify" cols="1">
                    <div v-if="statusInput[index]">
                      <v-icon
                        v-can:permission="'login-adicional#update'"
                        size="23"
                        @click="changeStatus(index)"
                        slot="append"
                        color="warning"
                        >mdi-pencil
                      </v-icon>
                      <v-icon
                        v-can:permission="'login-adicional#delete'"
                        size="23"
                        @click="deleteLoginAdditional(item)"
                        color="error"
                      >
                        mdi-trash-can
                      </v-icon>
                    </div>
                    <div v-if="!statusInput[index]">
                      <v-icon
                        size="23"
                        @click="changeStatus(index)"
                        slot="append"
                        color="error"
                      >
                        mdi-close
                      </v-icon>
                      <v-icon
                        size="23"
                        @click="updateLoginAdditional(item)"
                        color="success"
                      >
                        mdi-check-bold
                      </v-icon>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :disabled="!multipleEdit" @click="atualizarTodos" color="primary"
          >Salvar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import toast from "@/commom/toast";
import loginsAdicionais from "@/services/http/rpa/LoginsAdicionais";
export default {
  props: {
    labelBtn: {
      type: String,
    },
    dialog: {
      type: Boolean,
      default: true,
    },
    idLogin: {
      type: Number,
    },
  },

  data: () => ({
    loading: false,
    configList: {},
    multipleEdit: false,
    statusInput: [],
    rpa_login_id: [],
    loginsAdicionais: [],
    itemsForm: {
      chave: "",
      valor: "",
      rpa_login_id: "",
    },
    rules: {
      required: (value) => !!value || "Campo obrigatório.",
    },
  }),
  methods: {
    async atualizarTodos() {
      const indexAtivos = [];
      this.statusInput.forEach((status, index) => {
        if (!status) {
          indexAtivos.push(index);
        }
      });

      const promisses = indexAtivos.map(async (index) => {
        await loginsAdicionais(this.loginsAdicionais[index].id).update(
          this.loginsAdicionais[index]
        );
      });

      try {
        this.loading = true;
        await Promise.all(promisses);
        toast("success", "Logins adicionais editados");
        this.getLoginsAdicionais();
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },
    async closeModal() {
      this.$emit("update:dialog", false);
      this.$emit("resetClick");
      this.setStatusDisabled();
      this.loginsAdicionais = [];
      this.$refs.formAdditionalLogin.reset();
      this.itemsForm.login = "";
      this.rpa_login_id = null;
    },

    async getLoginsAdicionais() {
      this.$refs.formAdditionalLogin.reset();
      await this.mountList();
      this.setStatusDisabled();
      this.multipleEdit = false;
    },

    async createLoginAdditional() {
      this.loading = true;
      this.itemsForm.rpa_login_id = this.idLogin;
      if (!this.$refs.formAdditionalLogin.validate()) return;
      try {
        await loginsAdicionais().store(this.itemsForm);
        toast("success", "Login adicional cadastrado!");

        await this.getLoginsAdicionais();
      } catch (err) {
        toast("error", "Erro inesperado");
      }
    },

    async updateLoginAdditional(item) {
      this.loading = true;
      try {
        await loginsAdicionais(item.id).update(item);
        toast("success", "Login adicional editado");
        this.getLoginsAdicionais();
      } catch (err) {
        toast("error", "Erro interno");
        console.error(err);
      } finally {
        this.loading = true;
      }
    },
    async deleteLoginAdditional(item) {
      let res = await this.$swal({
        title: "Você tem certeza?",
        text: "Isso não pode ser desfeito",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, apagar login",
        cancelButtonText: "Cancelar",
      });
      if (!res.isConfirmed) return;
      this.loading = true;
      try {
        await loginsAdicionais(item.id).delete();
        toast("success", "Login removido");
        this.getLoginsAdicionais();
      } catch (err) {
        toast("error", "Erro inesperado");
      } finally {
        this.loading = true;
      }
    },

    changeStatus(index) {
      this.$set(this.statusInput, index, !this.statusInput[index]);
    },

    setStatusDisabled() {
      this.statusInput.map((j, i) => this.$set(this.statusInput, i, true));
    },

    generateConfigList(listLogins) {
      listLogins.map((value, index) => {
        this.statusInput.push(true);
      });
    },

    async fetchLoginsAdicionais() {
      let { data } = await loginsAdicionais().show({
        rpa_login_id: this.rpa_login_id,
        per_page: -1,
      });
      this.loginsAdicionais = data.data;
    },

    async mountList() {
      await this.fetchLoginsAdicionais();
      this.statusInput = [];
      this.generateConfigList(this.loginsAdicionais);
      // this.rpa_login_id = null;
      this.loading = false;
    },
  },

  mounted() {
    document.addEventListener("keydown", (e) => {
      if (e.key == "Escape") {
        this.closeModal();
      }
    });
  },

  watch: {
    idLogin(val) {
      if (val) this.rpa_login_id = val;
    },

    async rpa_login_id(value) {
      if (value) await this.mountList();
    },
    statusInput() {
      const indexAtivos = [];
      this.statusInput.forEach((status, index) => {
        if (!status) {
          indexAtivos.push(index);
        }
      });
      if (indexAtivos.length > 1) {
        console.log("jajajja");
        this.multipleEdit = true;
      }
    },
  },
};
</script>
<style scoped lang="scss">
/* write SCSS here */
$input-font-size: "70px";
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active em versões anteriores a 2.1.8 */ {
  opacity: 0;
}
</style>
